<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-corporate.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>
import { getCookie, setHoursCookie } from '@/utils/auth'
import { versionKontrol } from '@/api/version'

export default {
  name: 'app',
  metaInfo: {
    title: 'Index',
    titleTemplate: '%s - Hayrat Uzaktan Eğitim Merkezi'
  },
  data () {
    return {
      hataVarMi: true,
      socketKontrol: null,
      onlineUsers: {}
    }
  },
  watch: {
    $route: function (n, o) {
      if (window.ws) {
        window.ws.send(n.path)
      }
    }
  },
  async mounted () {
    if (this.hayratEgitimMi) {
      this.socketKontrol = () => {
        if (this.hataVarMi) {
          this.webSocketBaglan()
        }
      }
      setInterval(this.socketKontrol, 2500)
    }
  },
  async created () {
    await this.apidenversionKontrol()
  },
  methods: {
    async apidenversionKontrol () {
      try {
        const result = await versionKontrol()
        console.log('API Front-End Version', result.version)
        const localVersion = getCookie('frontend-version')
        console.log('Local Front-End Version', localVersion)
        if (!localVersion) {
          setHoursCookie('frontend-version', result.version, 8760)
          location.reload()
        }
        if (result.version !== localVersion) {
          setHoursCookie('frontend-version', result.version, 8760)
          location.reload()
        }
        console.log('Time', new Date())
      } catch (e) {
        console.error(e)
      }
    },
    webSocketBaglan () {
      console.log('baglanti deneniyor')
      if (getCookie('tokenGrupTakip') && !window.ws) {
        const adres = process.env.NODE_ENV === 'development' ? 'ws://localhost:1313/ws/baglanti/?token=' : window.location.origin.replace('https', 'wss') + '/ws/baglanti/?token='
        window.ws = new WebSocket(adres + getCookie('tokenGrupTakip'))
        window.ws.onopen = (evt) => {
          console.log('Connection open ...')
          this.hataVarMi = false
        }

        window.ws.onmessage = (evt) => {
          const onlineOlanlar = JSON.parse(evt.data)
          this.onlineUsers = onlineOlanlar
        }

        window.ws.onerror = (evt) => {
          console.log('Connection error =>.', evt)
          this.hataVarMi = true
        }

        window.ws.onclose = (evt) => {
          console.log('Close closed =>.', evt)
          this.hataVarMi = true
        }
      }
    }
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  },
  beforeDestroy () {
    if (this.ws) {
      this.ws.close()
      this.ws = null
    }
  }
}
</script>
<style>
.toast-body {
  white-space: pre-line !important;
}

.bv-no-focus-ring {
  width: 100%;
}
</style>
